import * as React from "react";

import backgroundColoursCss from "../../templates/utils/backgroundColoursCss";
import styled from "../../theme/styled";
import { ColumnWidthWrapper } from "../confines-wrappers";
import DynamicVideo from "../dynamic-video";
import {
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

interface IParagraphBoxOutVideoColumnWidthWrapper {
  className: string;
  type: IFieldTechnicalArticleColumnType;
  backgroundColors?: string[];
}

const ParagraphBoxOutVideoColumnWidthWrapper = styled<
  IParagraphBoxOutVideoColumnWidthWrapper,
  "div"
>("div")`
  .content-container {
    ${props => backgroundColoursCss(props.backgroundColors)};

    .content-wrapper {
      .image {
        padding-top: 8%;
        width: 100%;

        &:first-child {
          padding-top: 0;
        }
      }
    }
  }
`;

const ParagraphBoxOutVideoColumnWidth = ({ type, content }: IProps) => {
  const backgroundColors = content.field_background_colour_s_;
  const videoUrl = content.field_video_url;
  const autoplay = content.field_video_autoplay;
  const videoCaption = content.field_video_caption;
  const videoCaptionColour = content.field_video_caption_colour;

  if (!videoUrl) {
    return null;
  }

  return (
    <ParagraphBoxOutVideoColumnWidthWrapper
      className="paragraph-box-out-video-column-width"
      type={type}
      backgroundColors={backgroundColors}
    >
      <div className="content-container">
        <ColumnWidthWrapper>
          <div className="content-wrapper">
            <DynamicVideo
              videoUrl={videoUrl}
              autoplay={autoplay}
              videoCaption={videoCaption}
              videoCaptionColour={videoCaptionColour}
            />
          </div>
        </ColumnWidthWrapper>
      </div>
    </ParagraphBoxOutVideoColumnWidthWrapper>
  );
};

export default ParagraphBoxOutVideoColumnWidth;
